import ApplicationSerializer from 'lumen/serializers/application';

export default class AiUsageSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'ai_usages' || key === 'ai_usage') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('reviews/ai-usage');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }
}
